import { GetterTree } from 'vuex'
import { State } from './state'


export function totalStatsDeklaracje (state: State): number {
    return state.totalStatsDeklaracje;
}

export function totalStatsDeklaracjeLoading (state: State): boolean {
    return state.totalStatsDeklaracjeLoading;
}

export function totalStatsDeklaracjeUpdatedAt (state: State): string {
    return state.totalStatsDeklaracjeUpdatedAt;
}

export function totalStatsPobrania (state: State): number {
    return state.totalStatsPobrania;
}

export function totalStatsPobraniaLoading (state: State): boolean {
    return state.totalStatsPobraniaLoading;
}

export function totalStatsPobraniaUpdatedAt (state: State): string {
    return state.totalStatsPobraniaUpdatedAt;
}

export function totalStatsUruchomienia (state: State): number {
    return state.totalStatsUruchomienia;
}

export function totalStatsUruchomieniaLoading (state: State): boolean {
    return state.totalStatsUruchomieniaLoading;
}

export function totalStatsUruchomieniaUpdatedAt (state: State): string {
    return state.totalStatsUruchomieniaUpdatedAt;
}

export function totalStatsDeklaracjeLastYear (state: State): number {
    return state.totalStatsDeklaracjeLastYear;
}

export function totalStatsDeklaracjeLastYearLoading (state: State): boolean {
    return state.totalStatsDeklaracjeLastYearLoading;
}

export function totalStatsDeklaracjeLastYearUpdatedAt (state: State): string {
    return state.totalStatsDeklaracjeLastYearUpdatedAt;
}

export function totalStatsDeklaracjeDifferenceComparedToLastYear (state: State): string {
    if (state.totalStatsDeklaracjeLastYear == 0) return '+100';
    if (state.totalStatsDeklaracje == 0) return '-100';

    if (state.totalStatsDeklaracje > state.totalStatsDeklaracjeLastYear) {
        return '+' + Math.round((state.totalStatsDeklaracje - state.totalStatsDeklaracjeLastYear) / state.totalStatsDeklaracjeLastYear * 100);
    }
    else {
        return '-' + Math.round((state.totalStatsDeklaracjeLastYear - state.totalStatsDeklaracje) / state.totalStatsDeklaracje * 100);
    }
}

export function aggregatedStatsDeklaracjeLoading (state: State): boolean {
    return (state.aggregatedStatsDeklaracjeLoading || state.aggregatedStatsDeklaracjeLastYearLoading);
}

export function aggregatedStatsDeklaracjeDatasets (state: State): object {
    return state.aggregatedStatsDeklaracjeDatasets;
}

export function aggregatedStatsDeklaracjeDateTo (state: State): string {
    return state.aggregatedStatsDeklaracjeDateTo;
}

export function aggregatedStatsDeklaracjeUpdatedAt (state: State): string {
    return state.aggregatedStatsDeklaracjeUpdatedAt;
}

export function aggregatedStatsUruchomieniaLoading (state: State): boolean {
    return (state.aggregatedStatsUruchomieniaLoading || state.aggregatedStatsUruchomieniaLastYearLoading);
}

export function aggregatedStatsUruchomieniaDatasets (state: State): object {
    return state.aggregatedStatsUruchomieniaDatasets;
}
export function aggregatedStatsUruchomieniaDateTo (state: State): string {
    return state.aggregatedStatsUruchomieniaDateTo;
}

export function aggregatedStatsUruchomieniaUpdatedAt (state: State): string {
    return state.aggregatedStatsUruchomieniaUpdatedAt;
}

export function  statsTopOperatingSystemsLoading (state: State): boolean {
    return state.statsTopOperatingSystemsLoading;
}

export function statsTopOperatingSystemsDataset (state: State): object {
    return state.statsTopOperatingSystemsDataset;
}

export function statsTopOperatingSystemsUpdatedAt (state: State): string {
    return state.statsTopOperatingSystemsUpdatedAt;
}

export function statsTopBrowsersLoading (state: State): boolean {
    return ((state.statsTopBrowsersLoading && state.statsTopBrowsersPage == 1) || state.statsTopBrowsersAggregatedLoading);
}

export function statsTopBrowsersPageLoading (state: State): boolean {
    return state.statsTopBrowsersLoading;
}

export function statsTopBrowsersData (state: State): object {
    return state.statsTopBrowsersData;
}

export function statsTopBrowsersPage (state: State): number {
    return state.statsTopBrowsersPage;
}

export function statsTopBrowsersCurrentPage (state: State): number {
    return state.statsTopBrowsersCurrentPage;
}

export function statsTopBrowsersTotal (state: State): number {
    return state.statsTopBrowsersTotal;
}

export function statsTopBrowsersAggregatedData (state: State): object {
    return state.statsTopBrowsersAggregatedData;
}

export function statsTopIPLoading (state: State): boolean {
    return (state.statsTopIPLoading && state.statsTopIPPage == 1);
}

export function statsTopIPPageLoading (state: State): boolean {
    return state.statsTopIPLoading;
}

export function statsTopIPData (state: State): object {
    return state.statsTopIPData;
}

export function statsTopIPPage (state: State): number {
    return state.statsTopIPPage;
}

export function statsTopIPCurrentPage (state: State): number {
    return state.statsTopIPCurrentPage;
}

export function statsTopIPTotal (state: State): number {
    return state.statsTopIPTotal;
}

export function statsTopPobraniaReferersLoading (state: State): boolean {
    return (state.statsTopPobraniaReferersLoading && state.statsTopPobraniaReferersPage == 1);
}

export function statsTopPobraniaReferersPageLoading (state: State): boolean {
    return state.statsTopPobraniaReferersLoading;
}

export function statsTopPobraniaReferersData (state: State): object {
    return state.statsTopPobraniaReferersData;
}

export function statsTopPobraniaReferersPage (state: State): number {
    return state.statsTopPobraniaReferersPage;
}

export function statsTopPobraniaReferersCurrentPage (state: State): number {
    return state.statsTopPobraniaReferersCurrentPage;
}

export function statsTopPobraniaReferersTotal (state: State): number {
    return state.statsTopPobraniaReferersTotal;
}


export default <GetterTree<State, any>> {
    totalStatsDeklaracje,
    totalStatsDeklaracjeLoading,
    totalStatsDeklaracjeUpdatedAt,
    totalStatsPobrania,
    totalStatsPobraniaLoading,
    totalStatsPobraniaUpdatedAt,
    totalStatsUruchomienia,
    totalStatsUruchomieniaLoading,
    totalStatsUruchomieniaUpdatedAt,
    totalStatsDeklaracjeLastYear,
    totalStatsDeklaracjeLastYearLoading,
    totalStatsDeklaracjeLastYearUpdatedAt,
    totalStatsDeklaracjeDifferenceComparedToLastYear,
    aggregatedStatsDeklaracjeLoading,
    aggregatedStatsDeklaracjeDatasets,
    aggregatedStatsDeklaracjeDateTo,
    aggregatedStatsDeklaracjeUpdatedAt,
    aggregatedStatsUruchomieniaLoading,
    aggregatedStatsUruchomieniaDatasets,
    aggregatedStatsUruchomieniaDateTo,
    aggregatedStatsUruchomieniaUpdatedAt,
    statsTopOperatingSystemsLoading,
    statsTopOperatingSystemsDataset,
    statsTopOperatingSystemsUpdatedAt,
    statsTopBrowsersLoading,
    statsTopBrowsersPageLoading,
    statsTopBrowsersData,
    statsTopBrowsersPage,
    statsTopBrowsersCurrentPage,
    statsTopBrowsersTotal,
    statsTopBrowsersAggregatedData,
    statsTopIPLoading,
    statsTopIPPageLoading,
    statsTopIPData,
    statsTopIPPage,
    statsTopIPCurrentPage,
    statsTopIPTotal,
    statsTopPobraniaReferersLoading,
    statsTopPobraniaReferersPageLoading,
    statsTopPobraniaReferersData,
    statsTopPobraniaReferersPage,
    statsTopPobraniaReferersCurrentPage,
    statsTopPobraniaReferersTotal,
}
